import { BinaryEntity } from '@edgvr-front/binaries/domain';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  BINARIES_FEATURE_KEY,
  BinariesFeatureState,
  latestAdapter,
} from '../reducers';

export const binariesFeatureState =
  createFeatureSelector<BinariesFeatureState>(BINARIES_FEATURE_KEY);

const { selectAll: selectAllLatest } = latestAdapter.getSelectors();

export const latest = createSelector(
  binariesFeatureState,
  (state: BinariesFeatureState) =>
    selectAllLatest(state.latest).map((_) => new BinaryEntity(_))
);

export const isLoading = createSelector(
  binariesFeatureState,
  (state: BinariesFeatureState) => state.latest.isLoading
);
